import { PulsoBlack } from '../../assets/pulso/black'
import { PulsoBlackSymbol } from '../../assets/pulso/black-symbol'
import { PulsoColored } from '../../assets/pulso/colored'
import { PulsoColoredSymbol } from '../../assets/pulso/colored-symbol'
import { PulsoWhite } from '../../assets/pulso/white'
import { PulsoWhiteSymbol } from '../../assets/pulso/white-symbol'
import { LogoWhithoutVariant } from '../without-variants'

export const logos = {
  white: {
    large: <PulsoWhite width={90} height={48} />,
    huge: <PulsoWhite width={135} height={64} />,
    enormous: <PulsoWhite width={180} height={80} />,
  },
  black: {
    large: <PulsoBlack width={90} height={48} />,
    huge: <PulsoBlack width={135} height={64} />,
    enormous: <PulsoBlack width={180} height={80} />,
  },
  colored: {
    large: <PulsoColored width={90} height={48} />,
    huge: <PulsoColored width={135} height={64} />,
    enormous: <PulsoColored width={180} height={80} />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}

export const symbols = {
  white: {
    large: <PulsoWhiteSymbol width={30} height={48} />,
    huge: <PulsoWhiteSymbol width={44} height={64} />,
    enormous: <PulsoWhiteSymbol width={58} height={80} />,
  },
  black: {
    large: <PulsoBlackSymbol width={30} height={48} />,
    huge: <PulsoBlackSymbol width={44} height={64} />,
    enormous: <PulsoBlackSymbol width={58} height={80} />,
  },
  colored: {
    large: <PulsoColoredSymbol width={30} height={48} />,
    huge: <PulsoColoredSymbol width={44} height={64} />,
    enormous: <PulsoColoredSymbol width={58} height={80} />,
  },
  'light-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  'dark-green': {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
  yellow: {
    large: <LogoWhithoutVariant />,
    huge: <LogoWhithoutVariant />,
    enormous: <LogoWhithoutVariant />,
  },
}
